import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './base.js';

export const weeklyReportPayloadSchema = z.object({
  week_key: z.string().regex(/^\d{4}-W\d{2}$/),
  week_start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  counts: z.object({
    created: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    overdue: z.number().int().nonnegative(),
    carried_over: z.number().int().nonnegative(),
  }),
  by_project: z
    .array(
      z.object({
        project_id: uuidSchema.nullable(),
        project_name: z.string(),
        completed: z.number().int().nonnegative(),
        open: z.number().int().nonnegative(),
      }),
    )
    .default([]),
  by_priority: z.record(z.string(), z.number().int().nonnegative()).default({}),
  highlights: z.array(z.string()).default([]),
  narrative: z.string().nullable().default(null),
});

export type WeeklyReportPayload = z.infer<typeof weeklyReportPayloadSchema>;

export const reportWeeklySchema = z.object({
  user_id: uuidSchema,
  week_start: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  payload: weeklyReportPayloadSchema,
  generated_at: isoTimestampSchema,
});

export type ReportWeekly = z.infer<typeof reportWeeklySchema>;
